import { Select } from 'antd';
import gql from 'graphql-tag';
import React from 'react';
import { useQuery } from 'react-apollo';

const UNIQUE_EVENT_VENDORS_QUERY = gql`
  query UniqueEventVendors {
    uniqueEventVendors
  }
`;

interface Props {
  value?: string | null;
  onChange: (value: string) => void;
}

function EventVendorFilter(props: Props) {
  const { value, onChange } = props;

  const { data, error, loading } = useQuery(UNIQUE_EVENT_VENDORS_QUERY);

  return (
    <Select
      value={value || undefined}
      style={{ minWidth: '200px', maxWidth: '500px' }}
      onChange={onChange}
      dropdownMatchSelectWidth={false}
      placeholder="Select Vendor"
      maxTagCount={2}
      loading={loading}
      maxTagTextLength={48}
      maxTagPlaceholder={(extraValues) => {
        return <>+&nbsp;{extraValues.length}</>;
      }}
    >
      {error && (
        <Select.Option disabled key="error" value="Could not load vendors">
          Could not load vendors
        </Select.Option>
      )}

      <Select.Option key="all" value={'all'}>
        {'All Vendors'}
      </Select.Option>

      {!loading &&
        data?.uniqueEventVendors?.map((o, idx) => {
          return (
            <Select.Option key={`${o}_${idx}`} value={o}>
              {o}
            </Select.Option>
          );
        })}
    </Select>
  );
}

export default EventVendorFilter;
